import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/EditFormModal";
import NotificationForm from "./NotificationForm";
const EditSelfTherapy = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Edit_Notification_Modal, initialValues, Loader } = faqProps;
  const [form] = Form.useForm();

  return (
    <div>
      <FormModal
        modalTitle="Edit Notification"
        submitButtonText="Update"
        cancelButtonText="Cancel"
        editApiRequest="EditRecord"
        apiLoader="StartSpinner"
        editApiMethod="PUT"
        editApiName="editNotification"
        ModalName="Edit_Notification_Modal"
        confirmLoading={Loader}
        ModalType="Hide_Modal"
        visible={Edit_Notification_Modal ? Edit_Notification_Modal : false}
        initialValues={initialValues}
        width={500}
        form={form}
        recordName="notificationList"
      >
        <NotificationForm />
      </FormModal>
    </div>
  );
};

export default EditSelfTherapy;
